import {
  deleteSessionStorage,
  hideSpinner,
  showSpinner,
} from "../../utils/helperServices";
import microService from "../../utils/microServices";
import * as types from "../actionTypes/index";
import ajaxService from "../../utils/ajaxServices";
import {
  Features
} from "../../utils/featuresService";
import {
  errorCodes,
  legacySessionData,
  maskMsisdn,
  upgradeStages,
} from "../../services/upgradeService";
import config from "../../config/index";
import { Cookie } from "../../components/atoms/DependencyHelper";

const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;

export const displayHideUpgradeModal = (value) => (dispatch) => {
  dispatch({ type: types.DISPLAY_HIDE_MODAL, payload: value });
};

export const clearUpgradeJourney =
  (clearAll = false) =>
  (dispatch) => {
    deleteSessionStorage("isNotshowQualifyingDeals");
    legacySessionData.forEach((item) => deleteSessionStorage(item));
    if (clearAll) {
      dispatch({ type: types.CLEAR_ENTIRE_JOURNEY });
    } else {
      dispatch({ type: types.CLEAR_UPGRADE_JOURNEY_STATUS });
      dispatch({ type: types.SET_CONTRACT_MODE, payload: 'new-contract' });
    }
  };

export const updateCanReciveOTP = (value) => (dispatch) => {
  dispatch({ type: types.UPDATE_CAN_RECEIVE_OTP, payload: value });
};

export const updateMsisdnStatus = (number, status) => (dispatch) => {
  dispatch({
    type: types.UPDATE_MSISDN_STATUS,
    payload: { status: status, number: number },
  });
};

export const updateEligibiltyCheckStatus = (value) => (dispatch) => {
  dispatch({
    type: types.UPDATE_ELIGIBILITY_CHECK_STATUS,
    payload: value,
  });
};

export const updateJourneyStatus =
  (value, status = upgradeStages.TECHNICAL_ERROR) =>
  (dispatch) => {
    dispatch({
      type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
      payload: {
        status: status,
        code: value,
      },
    });
  };

export const generateOneTimePin = (msisdn) => async (dispatch) => {
  try {
    showSpinner();
    const params = [
      {
        address: msisdn,
        message: "otp-warning-sms-message",
        otpMessageProperties: {
          additionalProp1: "string",
          additionalProp2: "string",
          additionalProp3: "string",
        },
        type: "SMS",
      },
    ];
    const responseData = await microService.post(
      "api",
      "oneTimePin",
      params,
      null,
      false,
      [msisdn]
    );
    if (responseData.fail) {
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: {
          status: upgradeStages.TECHNICAL_ERROR,
          code: errorCodes.otp_service_down,
        },
      });
    } else {
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: { status: upgradeStages.OTP_ENRTY, code: null },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

const setToken = (token) => {
  if (token && token?.response?.headers) {
    Cookie.set("eligibility-token", token?.response?.headers["x-auth-jwt"]);
  }
};

export const getAllEligibility = (msisdn, otp) => async (dispatch) => {
  let responseData;
  try {
    showSpinner();
    const params = {
      id: msisdn,
      key: "UPGRADE_ELIGIBILITY",
      otp: otp,
      msisdn: msisdn,
    };

    responseData = await microService.post(
      "api",
      "getAllEligibility",
      params,
      null,
      false
    );

    if (responseData.fail) {
      if (responseData.error.status === 422) {
        dispatch({
          type: types.INVALID_OTP,
        });
      } else if (responseData.error.status === 400) {
        dispatch({
          type: types.MSISDN_BLOCKED,
        });
      } else if (responseData.error.status === 401) {
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: {
            status: upgradeStages.TECHNICAL_ERROR,
            code: errorCodes.user_acc_error,
          },
        });
      } else {
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: {
            status: upgradeStages.TECHNICAL_ERROR,
            code: errorCodes.service_down,
          },
        });
      }
    } else {
      dispatch({ type: types.RESET_INVALID_OTPS });
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: { status: upgradeStages.UPGRADE_RESULT, code: null },
      });
      setToken(responseData);
      dispatch({
        type: types.UPDATE_ELIGIBILITY_DATA,
        payload: {
          data: responseData?.response?.data || {},
        },
      });
      dispatch({
        type: types.PAST_TOKEN,
        payload: {
          token: responseData?.response?.headers,
        },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    setToken(responseData);
    hideSpinner();
  }
};

export const fetchAlternateNumbers = (msisdn) => async (dispatch) => {
  try {
    showSpinner();
    const params = { docType: "MSISDN" };
    const reqParams = [msisdn];
    const responseData = await microService.get(
      "api",
      "getMSIDNForAuthentication",
      params,
      false,
      reqParams
    );
    const dispatchData = () =>
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: {
          status: upgradeStages.TECHNICAL_ERROR,
          code: errorCodes.code_otp_no_alternative,
        },
      });

    if (responseData.fail) {
      if (responseData.error.status === 404) {
        dispatchData();
      } else {
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: {
            status: upgradeStages.TECHNICAL_ERROR,
            code: errorCodes.service_down,
          },
        });
      }
    } else {
      if (
        responseData.response?.data?.result &&
        responseData.response?.data?.result.length > 0
      ) {
        dispatch({
          type: types.ADD_ALTERNATE_NUMBERS,
          payload: {
            data: responseData.response?.data?.result,
          },
        });
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: { status: upgradeStages.NUMBER_SELECT, code: null },
        });
      } else {
        dispatchData();
      }
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

export const getEligibilityForAlternativeNumbers =
  (msisdn, maskedMsisdn, otp) => async (dispatch) => {
    let responseData;
    try {
      showSpinner();
      const params = {
        idNumber: msisdn,
        docType: "MSISDN",
        maskedMsisdn: maskedMsisdn,
        otp: otp,
        msisdn: msisdn,
      };

      responseData = await microService.post(
        "api",
        "getEligibilityForAlternativeNumbers",
        params,
        null,
        false
      );
      if (responseData.fail) {
        if (responseData.error.status === 401) {
          dispatch({
            type: types.INVALID_OTP,
          });
        } else {
          dispatch({
            type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
            payload: {
              status: upgradeStages.TECHNICAL_ERROR,
              code: errorCodes.service_down,
            },
          });
        }
      } else {
        setToken(responseData);
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: { status: upgradeStages.UPGRADE_RESULT, code: null },
        });
        dispatch({
          type: types.UPDATE_ELIGIBILITY_DATA,
          payload: {
            data: responseData?.response?.data || {},
          },
        });
      }
    } catch (error) {
      hideSpinner();
    } finally {
      setToken(responseData);
      hideSpinner();
    }
  };

export const generateOTP = (msisdn, maskedMsisdn) => async (dispatch) => {
  try {
    showSpinner();
    const urlParams = `?idNumber=${msisdn}&docType=MSISDN&maskedMsisdn=${maskedMsisdn}`;

    const responseData = await microService.post(
      "api",
      "generateOtp",
      {},
      null,
      false,
      null,
      urlParams
    );
    if (responseData.fail) {
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: {
          status: upgradeStages.TECHNICAL_ERROR,
          code: errorCodes.otp_service_down,
        },
      });
    } else {
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: { status: upgradeStages.OTP_ENRTY, code: null },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

export const eligibilityForLinkedNumbersList =
  (msisdns, name = "test") =>
  async (dispatch) => {
    try {
      showSpinner();
      const params = { msisdn: msisdns.join(","), sendSms: false, name: name };
      const responseData = await microService.get(
        "api",
        "eligibilityForLinkedNumbersList",
        params,
        false,
        null,
        null,
        true
      );
      if (responseData.fail) {
        if (responseData.error.status === 401) {
          dispatch({
            type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
            payload: {
              status: upgradeStages.TECHNICAL_ERROR,
              code: errorCodes.user_acc_error,
            },
          });
        } else {
          dispatch({
            type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
            payload: {
              status: upgradeStages.TECHNICAL_ERROR,
              code: errorCodes.logged_user_service_down,
            },
          });
        }
      } else {
        dispatch({
          type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
          payload: {
            status: upgradeStages.UPGRADE_RESULT,
            code: null,
          },
        });
        dispatch({
          type: types.UPDATE_LOGGED_IN_USER_ELIGIBILITY_DATA,
          payload: {
            data: responseData?.response?.data,
          },
        });
        return responseData?.response?.data;
      }
    } catch (error) {
      hideSpinner();
    } finally {
      hideSpinner();
    }
  };

export const setSelectedDisplayData = (payload) => async (dispatch) => {
  dispatch({
    type: types.UPDATE_SELECTED_DISPLAY_DATA,
    payload,
  });
};

export const fetchDisplayDetails = (resultCode) => async (dispatch) => {
  try {
    showSpinner();
    dispatch({
      type: types.UPDATE_DISPLAY_DATA,
      payload: {},
    });
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "upgradeResult",
      [resultCode]
    );
    dispatch({
      type: types.UPDATE_DISPLAY_DATA,
      payload: result && result.length && result[0],
    });
  } catch (error) {
    dispatch({
      type: types.UPDATE_DISPLAY_DATA,
      payload: {
        analyticTitle: "upgradeeligibility_logged_500",
        category: "Upgrade",
        icon: `${imagePrefix}/assets/images/icon-cross.svg`,
        primaryCTAText: "Call me back",
        primaryCTAURL: "/shopping/forms/ecommerce",
        primaryEnabled: "Yes",
        resultCode: "upgradeeligibility_logged_500",
        resultHTML: false,
        resultText:
          "We’re not able to check your upgrade status right now. Please try again later, or have one of our consultants contact you.",
        resultTitle: "Something went wrong",
        secondaryCTAText: "Go to home page",
        secondaryCTAURL: "/",
        secondaryEnabled: "Yes",
      },
    });
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

export const displayHideUpgradeTopbanner = (value) => (dispatch) => {
  dispatch({ type: types.TOP_BANNER_TOGGLE, payload: value });
};

export const displayHideUpgradeTopbannerModal = (value) => (dispatch) => {
  dispatch({ type: types.TOP_BANNER_MODAL_TOGGLE, payload: value });
};

export const stopUpgradeTopbannerModal = (value) => (dispatch) => {
  dispatch({ type: types.STOP_UPGRADE_MODAL_TOGGLE, payload: value });
};

export const fetchCreditFilters = (msisdn) => async (dispatch) => {
  try {
    showSpinner();
    const reqParams = [msisdn];
    const responseData = await microService.get(
      "api",
      "creditFilters",
      {},
      false,
      reqParams
    );
    dispatch({
      type: types.ADD_CREDIT_PROFILE,
      payload: responseData?.response?.data?.result?.creditFilter || {},
    });
    hideSpinner();
    return {
      fail: responseData?.fail,
      ...responseData?.response?.data?.result?.creditFilter,
    };
  } catch {
    hideSpinner();
  }
};

export const updateSelectedData = (data) => (dispatch) => {
  dispatch({
    type: types.UPDATE_SELECTED_UPGRADE_DATA,
    payload: {
      resultCode: data?.resultCode,
      data: data,
      msisdn: maskMsisdn(data?.msisdn),
    },
  });
};

export const updateData = (data) => (dispatch) => {
  dispatch({
    type: types.UPDATE_UPGRADE_DATA,
    payload: {
      resultCode: data?.resultCode,
      data: data,
      msisdn: maskMsisdn(data?.msisdn),
    },
  });
};

export const updateUpgradeRedirect = (link, text) => (dispatch) => {
  dispatch({
    type: types.UPDATE_UPGRADE_REDIRECT,
    payload: {
      link: link,
      text: text,
    },
  });
};

export const updateUnmaskedMsisdn = (value) => (dispatch) => {
  dispatch({ type: types.UPDATE_UNMASKED_MSISDN, payload: value });
};

export const getPastUsage = (msisdn) => async (dispatch) => {
  try {
    showSpinner();
    const queryParams = `?msisdn=${msisdn}`;
    const responseData = await microService.get(
      "api",
      "pastUsage",
      null,
      false,
      null,
      queryParams
    );

    if (responseData.fail) {
      dispatch({
        type: types.UPDATE_UPGRADE_JOURNEY_STATUS,
        payload: {
          status: upgradeStages.TECHNICAL_ERROR,
          code: errorCodes.otp_service_down,
        },
      });
    } else {
      dispatch({
        type: types.GET_PAST_USAGE,
        payload: {
          data: responseData?.response.data.result,
        },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

export const getLookupData = () => async (dispatch) => {
  try {
    showSpinner();

    const responseData = await microService.get(
      "api",
      "lookupData",
      null,
      false
    );
    if (responseData) {
      dispatch({
        type: types.GET_UPGRADE_BRANDS,
        payload: {
          data: responseData?.response?.data?.result,
        },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};

export const getDeviceModels = (brand) => async (dispatch) => {
  try {
    showSpinner();
    const queryParams = `?manufacturer=${brand}`;

    const responseData = await microService.get(
      "api",
      "upgradeDeviceModels",
      null,
      false,
      null,
      queryParams
    );
    if (responseData) {
      dispatch({
        type: types.GET_UPGRADE_MODELS,
        payload: {
          data: responseData?.response?.data?.result,
        },
      });
    }
  } catch (error) {
    hideSpinner();
  } finally {
    hideSpinner();
  }
};
export const getRecommendedDeals =
  (
    num,
    contract = "",
    brand = "",
    model = "",
    limit = "",
    deviceInstallment = "",
    financeIndicator = "",
    dealSku = "",
    simOnlyUpgradeFlg = "",
  ) =>
  async (dispatch) => {
    try {
      showSpinner();
      const contractUrl = contract ? `&simOnly=${contract}` : "";
      const brandsUrl = brand ? `&deviceManufacturer=${brand}` : "";
      const modelUrl = model ? `&device=${model}` : "";
      const limitUrl = limit ? `&tariffLimit=${limit}` : "";
      const financedThresholdAmount = deviceInstallment
        ? `&financedThresholdAmount=${Number(deviceInstallment)}`
        : "";
      const accountDealFlag = financeIndicator
        ? `&accountDealFlag=${financeIndicator}`
        : "";
      const dealSheetNumber = dealSku ? `&dealsheetNumber=${dealSku}` : "";
      const simOnlyUpgrade = (Features.get("simOnlyEarlyUpgradeEnabled") && simOnlyUpgradeFlg === "Y") ? `&simOnlyAnytimeUpgrade=${simOnlyUpgradeFlg}` : "";
      const queryParams = `?msisdn=${num}${contractUrl}${brandsUrl}${modelUrl}${limitUrl}${financedThresholdAmount}${accountDealFlag}${dealSheetNumber}${simOnlyUpgrade}`;

      const responseData = await microService.get(
        "api",
        "getRecommendedDeals",
        null,
        false,
        null,
        queryParams
      );
      if (responseData.fail) {
        dispatch({
          type: types.GET_RECOMMENDED_DEALS,
          payload: {
            data: responseData?.response?.data?.result,
            error: true,
          },
        });
      } else {
        dispatch({
          type: types.GET_RECOMMENDED_DEALS,
          payload: {
            data: responseData?.response?.data?.result,
            error: false,
          },
        });
      }
      hideSpinner();
      return responseData;
    } catch (error) {
      hideSpinner();
      return error;
    }
  };

export const checkIfdealQualifies = (value) => (dispatch) => {
  dispatch({ type: types.UPDATE_CHECK_DEAL_QUALIFIES, payload: value });
};

export const resetInvalidOtps = () => (dispatch) => {
  dispatch({ type: types.RESET_INVALID_OTPS });
};

export const toggleSnackBar = (value) => (dispatch) => {
  dispatch({ type: types.TOGGLE_SNACK_BAR, payload: value });
};

export const setDevicePrice = (value) => (dispatch) => {
  dispatch({ type: types.DEAL_PRICE, payload: value });
};

export const updateDealsReset = () => (dispatch) => {
  dispatch({ type: types.UPDATE_DEAL_GRID_RESET });
};

export const updateDealSelectionReset = () => (dispatch) => {
  dispatch({ type: types.UPDATE_DEAL_SELECTION_RESET });
};

export const updateProductGridReset = () => (dispatch) => {
  dispatch({ type: types.UPDATE_PRODUCT_GRID_RESET });
};

export const updateLinkedNumber = (msisdn) => (dispatch) => {
  dispatch({ type: types.UPDATE_LINKED_NUMBER, payload: msisdn });
};

export const displayInvalidOTPError = (value) => (dispatch) => {
  dispatch({ type: types.DISPLAY_INVALID_OTP_ERROR, payload: value });
};

export const updatedNextMsisdnSelected = (value) => (dispatch) => {
  dispatch({ type: types.UPDATE_NEXT_MSISDN_SELECTED, payload: value });
};

export const addDealToCart = (value) => (dispatch) => {
  dispatch({ type: types.ADD_DEAL_TO_CART, payload: value });
};
